module.exports = __webpack_public_path__ + "img/ban1.e4f4c29b.jpg";